export const getDateTimeText = (
  scheduledDateTime?: Date,
  scheduledDateTimeTo?: Date,
  scheduledStartTime?: string,
  scheduledEndTime?: string,
  showTime?: boolean,
  selectRange?: boolean,
): string => {
  let dateTimeText = '';

  if (scheduledDateTime) {
    dateTimeText = `${String(scheduledDateTime.getDate()).padStart(2, '0')}/${String(
      scheduledDateTime.getMonth() + 1,
    ).padStart(2, '0')}/${scheduledDateTime.getFullYear()} `;
    if (showTime && scheduledStartTime) {
      dateTimeText += scheduledStartTime;
    }
  }

  if (selectRange) {
    if (scheduledDateTime && scheduledDateTimeTo) {
      dateTimeText += ` to ${String(scheduledDateTimeTo.getDate()).padStart(2, '0')}/${String(
        scheduledDateTimeTo.getMonth() + 1,
      ).padStart(2, '0')}/${scheduledDateTimeTo.getFullYear()} `;

      if (showTime && scheduledEndTime) {
        dateTimeText += scheduledEndTime;
      }
    } else {
      dateTimeText = '';
    }
  }
  return dateTimeText;
};

export const applyClass = (trueClassname: string, falseClassname = '', condition: boolean) => {
  if (condition) {
    return trueClassname;
  } else {
    return falseClassname;
  }
};
